/* AUTO-GENERATED by scripts/gen_director_skill_types.py. */

export type Ref = string;
/**
 * Trust/source class visible to the Director runtime.
 */
export type SkillManifestSource = "builtin" | "user" | "published";
export type SkillId = string;
export type VersionId = string;
export type Version = number;
export type Name = string;
export type PublicSlug = string;
export type DisplayName = string;
export type Description = string;
export type UseWhen = string;
export type HowToUse = string;
export type OutputContent = string;
export type SkillCoverKind = "image" | "video";
export type MediaType = string;
export type FilePath = string;
export type PreviewPath = string;
export type ContentUrl = string;
export type PreviewUrl = string;
export type Ref1 = string;
export type VersionId1 = string;
export type Ref2 = string;
export type SkillSourceKind = "builtin" | "user";
export type SkillId1 = string;
export type VersionId2 = string | null;
export type Version1 = number | null;
export type Enabled = boolean;
export type IsActive = boolean;
export type SkillPublicationStatus = "private" | "pending" | "published" | "rejected" | "taken_down";
export type PublishedVersionId = string | null;
export type Name1 = string | null;
export type PublicSlug1 = string | null;
export type DisplayName1 = string | null;
/**
 * How one immutable skill version was authored.
 */
export type SkillCreateMethod = "chat" | "upload" | "seed";
export type Description1 = string | null;
export type UseWhen1 = string | null;
export type HowToUse1 = string | null;
export type OutputContent1 = string | null;
export type ContentMd = string | null;
export type Path = string;
export type MediaType1 = string;
export type SizeBytes = number;
export type ContentSha256 = string;
/**
 * Purpose of one immutable file in a skill version package.
 */
export type SkillFileRole = "document" | "reference" | "cover" | "cover_preview";
export type RuntimeReadable = boolean;
export type ContentUrl1 = string | null;
export type Files = SkillFileView[];
export type Path1 = string;
export type MediaType2 = string | null;
export type ContentBase64 = string;
export type MaxUserFileCount = number;
export type MaxUploadFileCount = number;
export type MaxUserPayloadBytes = number;
export type MaxDocumentBytes = number;
export type MaxReferenceFileBytes = number;
export type MaxReferenceResultBytes = number;
export type MaxReferenceRequestBytes = number;
export type MaxCoverImageBytes = number;
export type MaxCoverVideoBytes = number;
export type DocumentFilename = "SKILL.md";
export type ReferenceMediaType = "text/markdown";
export type ReferenceSuffix = ".md";
export type SkillPackageOperation =
  | SkillPutReferenceOperation
  | SkillDeleteReferenceOperation
  | SkillRenameReferenceOperation
  | SkillSetCoverOperation
  | SkillClearCoverOperation;
export type Op = "put_reference";
export type Op1 = "delete_reference";
export type Path2 = string;
export type Op2 = "rename_reference";
export type Path3 = string;
export type NewPath = string;
export type Op3 = "set_cover";
export type Op4 = "clear_cover";
export type Path4 = string;
export type MediaType3 = string;
export type ContentSha2561 = string;
export type ReadMode = "whole_file" | "section";
export type SectionId = string | null;
export type ContentBytes = number;
export type RemainingBudgetBytes = number;
export type ContentText = string;
export type ContentMd1 = string;
export type Valid = true;
export type Name2 = string;
export type DisplayName2 = string;
export type Description2 = string;
export type UseWhen2 = string;
export type HowToUse2 = string;
export type OutputContent2 = string;
export type ContentSha2562 = string;
export type ContentMd2 = string;
export type Activate = boolean;
/**
 * @maxItems 999
 */
export type Files1 = SkillFileUpload[];
export type CoverFilePath = string | null;
export type ContentMd3 = string;
export type ExpectedVersion = number | null;
export type Activate1 = boolean;
export type Files2 = SkillFileUpload[] | null;
export type CoverFilePath1 = string | null;
export type Operations =
  | (
      | SkillPutReferenceOperation
      | SkillDeleteReferenceOperation
      | SkillRenameReferenceOperation
      | SkillSetCoverOperation
      | SkillClearCoverOperation
    )[]
  | null;
export type ContentMd4 = string;
export type Filename = string;
export type Compatible = boolean;
export type Ref3 = string;
export type SkillId2 = string;
export type VersionId3 = string;
export type Version2 = number;
export type Name3 = string;
export type PublicSlug2 = string;
export type DisplayName3 = string;
export type Description3 = string;
export type UseWhen3 = string;
export type HowToUse3 = string;
export type OutputContent3 = string;
export type Enabled1 = boolean;
export type IsActive1 = boolean;
export type Path5 = string;
export type SharedContentBytes = number;
export type WholeFileContentBytes = number;
export type WholeFileReadable = boolean;
export type SectionId1 = string;
export type RawContentBytes = number;
export type EffectiveContentBytes = number;
export type Sections = SkillReferenceSectionSize[];
export type ReferenceSummaries = SkillReferenceValidationSummary[];
export type VersionId4 = string;
export type PublisherDisplayName = string;
export type Category = string;
/**
 * @maxItems 10
 */
export type Tags =
  | []
  | [string]
  | [string, string]
  | [string, string, string]
  | [string, string, string, string]
  | [string, string, string, string, string]
  | [string, string, string, string, string, string]
  | [string, string, string, string, string, string, string]
  | [string, string, string, string, string, string, string, string]
  | [string, string, string, string, string, string, string, string, string]
  | [string, string, string, string, string, string, string, string, string, string];
export type ChangeSummary = string;
export type DeprecationMessage = string | null;
export type SubmissionId = string;
export type SkillId3 = string;
export type VersionId5 = string;
export type Version3 = number;
export type Name4 = string;
export type PublicSlug3 = string;
export type DisplayName4 = string;
export type Description4 = string;
export type UseWhen4 = string;
export type HowToUse4 = string;
export type OutputContent4 = string;
export type ContentMd5 = string;
export type SkillSubmissionStatus = "pending" | "approved" | "rejected" | "unpublished" | "taken_down";
export type PublisherDisplayName1 = string;
export type Category1 = string;
export type Tags1 = string[];
export type ChangeSummary1 = string;
export type DeprecationMessage1 = string | null;
export type ReviewNote = string | null;
export type CreatedAt = string;
export type ReviewedAt = string | null;
export type WithdrawalNote = string | null;
export type WithdrawnAt = string | null;
export type ReportCount = number;
export type OpenReportCount = number;
export type Files3 = SkillFileView[];
export type Ref4 = string;
export type SkillId4 = string;
export type VersionId6 = string;
export type Version4 = number;
export type Name5 = string;
export type PublicSlug4 = string;
export type DisplayName5 = string;
export type Description5 = string;
export type UseWhen5 = string;
export type HowToUse5 = string;
export type OutputContent5 = string;
export type PublisherKind = "community";
export type IsOfficial = false;
export type PublisherDisplayName2 = string;
export type Category2 = string;
export type Tags2 = string[];
export type PublishedAt = string;
export type ChangeSummary2 = string;
export type DeprecationMessage2 = string | null;
export type InstallCount = number;
export type InstalledVersionId = string | null;
export type InstalledEnabled = boolean | null;
export type UpdateAvailable = boolean;
export type Items = SkillCatalogItem[];
export type NextOffset = number | null;
export type VersionId7 = string | null;
export type SkillId5 = string;
export type Ref5 = string;
export type PinnedVersionId = string;
export type Version5 = number;
export type Enabled2 = boolean;
export type Available = boolean;
export type UpdateAvailable1 = boolean;
export type Name6 = string;
export type PublicSlug5 = string;
export type DisplayName6 = string;
export type Description6 = string;
export type UseWhen6 = string;
export type HowToUse6 = string;
export type OutputContent6 = string;
export type PublisherKind1 = "community";
export type IsOfficial1 = false;
export type PublisherDisplayName3 = string;
export type Category3 = string;
export type Tags3 = string[];
export type ChangeSummary3 = string;
export type DeprecationMessage3 = string | null;
export type InstalledAt = string;
export type UpdatedAt = string;
export type SkillId6 = string;
export type Ref6 = string;
export type PinnedVersionId1 = string;
export type Version6 = number;
export type Enabled3 = boolean;
export type Available1 = boolean;
export type UpdateAvailable2 = boolean;
export type Name7 = string;
export type PublicSlug6 = string;
export type DisplayName7 = string;
export type Description7 = string;
export type UseWhen7 = string;
export type HowToUse7 = string;
export type OutputContent7 = string;
export type PublisherKind2 = "community";
export type IsOfficial2 = false;
export type PublisherDisplayName4 = string;
export type Category4 = string;
export type Tags4 = string[];
export type ChangeSummary4 = string;
export type DeprecationMessage4 = string | null;
export type InstalledAt1 = string;
export type UpdatedAt1 = string;
export type ContentMd6 = string;
export type Files4 = SkillFileView[];

/**
 * Code-generation envelope for client-visible skill contracts.
 */
export interface DirectorSkillClientContracts {
  manifest_item: SkillManifestItem;
  selection: SelectedDirectorSkillRequest;
  skill_view: SkillView;
  file_upload: SkillFileUpload;
  file_view: SkillFileView;
  cover_view: SkillCoverView;
  package_limits: SkillPackageLimits;
  skill_package_operation: SkillPackageOperation;
  runtime_file: SkillRuntimeFile;
  validate_request: SkillValidateRequest;
  validation_result: SkillValidationResult;
  create_request: SkillCreateRequest;
  create_version_request: SkillCreateVersionRequest;
  import_compatibility_request: SkillImportCompatibilityRequest;
  import_compatibility_result: SkillImportCompatibilityResult;
  version_result: SkillVersionResult;
  publication_submit_request: SkillPublicationSubmitRequest;
  publication_view: SkillPublicationView;
  catalog_item: SkillCatalogItem;
  catalog_page: SkillCatalogPage;
  install_request: SkillInstallRequest;
  installation_view: SkillInstallationView;
  installation_detail: SkillInstallationDetail;
}
/**
 * Metadata safe to place in the request-scoped Director manifest.
 */
export interface SkillManifestItem {
  ref: Ref;
  source: SkillManifestSource;
  skill_id: SkillId;
  version_id: VersionId;
  version: Version;
  name: Name;
  public_slug: PublicSlug;
  display_name: DisplayName;
  description: Description;
  use_when: UseWhen;
  how_to_use: HowToUse;
  output_content: OutputContent;
  cover?: SkillCoverView | null;
}
/**
 * Cover media plus the still image used by cards and hover previews.
 */
export interface SkillCoverView {
  kind: SkillCoverKind;
  media_type: MediaType;
  file_path: FilePath;
  preview_path: PreviewPath;
  content_url: ContentUrl;
  preview_url: PreviewUrl;
}
/**
 * Exact immutable skill version selected by an authenticated client.
 */
export interface SelectedDirectorSkillRequest {
  ref: Ref1;
  version_id: VersionId1;
}
/**
 * Visibility-projected API representation.
 *
 * Author-visible fields are optional so the serializer can omit any field
 * the caller may not see.  Identity and lifecycle fields are always present.
 */
export interface SkillView {
  ref: Ref2;
  source: SkillSourceKind;
  skill_id: SkillId1;
  version_id?: VersionId2;
  version?: Version1;
  enabled: Enabled;
  is_active: IsActive;
  publication_status?: SkillPublicationStatus;
  published_version_id?: PublishedVersionId;
  name?: Name1;
  public_slug?: PublicSlug1;
  display_name?: DisplayName1;
  create_method?: SkillCreateMethod | null;
  description?: Description1;
  use_when?: UseWhen1;
  how_to_use?: HowToUse1;
  output_content?: OutputContent1;
  content_md?: ContentMd;
  cover?: SkillCoverView | null;
  files?: Files;
}
/**
 * Metadata for one immutable file; bytes are read through ``content_url``.
 */
export interface SkillFileView {
  path: Path;
  media_type: MediaType1;
  size_bytes: SizeBytes;
  content_sha256: ContentSha256;
  role: SkillFileRole;
  runtime_readable: RuntimeReadable;
  content_url?: ContentUrl1;
}
/**
 * One base64-encoded nested file supplied while creating a version.
 */
export interface SkillFileUpload {
  path: Path1;
  media_type?: MediaType2;
  content_base64: ContentBase64;
}
/**
 * Server-authoritative upload limits exposed to skill editors.
 */
export interface SkillPackageLimits {
  max_user_file_count: MaxUserFileCount;
  max_upload_file_count: MaxUploadFileCount;
  max_user_payload_bytes: MaxUserPayloadBytes;
  max_document_bytes: MaxDocumentBytes;
  max_reference_file_bytes: MaxReferenceFileBytes;
  max_reference_result_bytes: MaxReferenceResultBytes;
  max_reference_request_bytes: MaxReferenceRequestBytes;
  max_cover_image_bytes: MaxCoverImageBytes;
  max_cover_video_bytes: MaxCoverVideoBytes;
  document_filename: DocumentFilename;
  reference_media_type: ReferenceMediaType;
  reference_suffix: ReferenceSuffix;
}
export interface SkillPutReferenceOperation {
  op: Op;
  file: SkillFileUpload;
}
export interface SkillDeleteReferenceOperation {
  op: Op1;
  path: Path2;
}
export interface SkillRenameReferenceOperation {
  op: Op2;
  path: Path3;
  new_path: NewPath;
}
export interface SkillSetCoverOperation {
  op: Op3;
  file: SkillFileUpload;
}
export interface SkillClearCoverOperation {
  op: Op4;
}
/**
 * Text reference returned to the Director on an explicit path read.
 */
export interface SkillRuntimeFile {
  path: Path4;
  media_type: MediaType3;
  content_sha256: ContentSha2561;
  read_mode: ReadMode;
  section_id?: SectionId;
  content_bytes: ContentBytes;
  remaining_budget_bytes: RemainingBudgetBytes;
  content_text: ContentText;
}
/**
 * Validate one complete raw ``SKILL.md`` before a create/version save.
 */
export interface SkillValidateRequest {
  content_md: ContentMd1;
}
/**
 * Safe manifest projections produced by the authoritative server parser.
 */
export interface SkillValidationResult {
  valid: Valid;
  name: Name2;
  display_name: DisplayName2;
  description: Description2;
  use_when: UseWhen2;
  how_to_use: HowToUse2;
  output_content: OutputContent2;
  content_sha256: ContentSha2562;
}
export interface SkillCreateRequest {
  content_md: ContentMd2;
  activate?: Activate;
  files?: Files1;
  cover_file_path?: CoverFilePath;
}
export interface SkillCreateVersionRequest {
  content_md: ContentMd3;
  expected_version?: ExpectedVersion;
  activate?: Activate1;
  files?: Files2;
  cover_file_path?: CoverFilePath1;
  operations?: Operations;
}
/**
 * Check whether an uploaded Markdown document needs canonical rewriting.
 */
export interface SkillImportCompatibilityRequest {
  content_md: ContentMd4;
  filename: Filename;
}
/**
 * Authoritative compatibility decision for the upload progress UI.
 */
export interface SkillImportCompatibilityResult {
  compatible: Compatible;
}
/**
 * Result of a draft save or activation.
 */
export interface SkillVersionResult {
  ref: Ref3;
  source: SkillManifestSource;
  skill_id: SkillId2;
  version_id: VersionId3;
  version: Version2;
  name: Name3;
  public_slug: PublicSlug2;
  display_name: DisplayName3;
  description: Description3;
  use_when: UseWhen3;
  how_to_use: HowToUse3;
  output_content: OutputContent3;
  cover?: SkillCoverView | null;
  enabled: Enabled1;
  is_active: IsActive1;
  create_method: SkillCreateMethod;
  reference_summaries?: ReferenceSummaries;
}
/**
 * Validation result for one Markdown reference file.
 */
export interface SkillReferenceValidationSummary {
  path: Path5;
  shared_content_bytes: SharedContentBytes;
  whole_file_content_bytes: WholeFileContentBytes;
  whole_file_readable: WholeFileReadable;
  sections?: Sections;
}
/**
 * Author-facing size information for one semantic reference section.
 */
export interface SkillReferenceSectionSize {
  section_id: SectionId1;
  raw_content_bytes: RawContentBytes;
  effective_content_bytes: EffectiveContentBytes;
}
export interface SkillPublicationSubmitRequest {
  version_id: VersionId4;
  publisher_display_name: PublisherDisplayName;
  category: Category;
  tags?: Tags;
  change_summary: ChangeSummary;
  deprecation_message?: DeprecationMessage;
}
export interface SkillPublicationView {
  submission_id: SubmissionId;
  skill_id: SkillId3;
  version_id: VersionId5;
  version: Version3;
  name: Name4;
  public_slug: PublicSlug3;
  display_name?: DisplayName4;
  description: Description4;
  use_when: UseWhen4;
  how_to_use: HowToUse4;
  output_content: OutputContent4;
  content_md: ContentMd5;
  status: SkillSubmissionStatus;
  publisher_display_name: PublisherDisplayName1;
  category: Category1;
  tags: Tags1;
  change_summary: ChangeSummary1;
  deprecation_message?: DeprecationMessage1;
  review_note?: ReviewNote;
  created_at: CreatedAt;
  reviewed_at?: ReviewedAt;
  withdrawal_note?: WithdrawalNote;
  withdrawn_at?: WithdrawnAt;
  report_count?: ReportCount;
  open_report_count?: OpenReportCount;
  cover?: SkillCoverView | null;
  files?: Files3;
}
export interface SkillCatalogItem {
  ref: Ref4;
  skill_id: SkillId4;
  version_id: VersionId6;
  version: Version4;
  name: Name5;
  public_slug: PublicSlug4;
  display_name?: DisplayName5;
  description: Description5;
  use_when: UseWhen5;
  how_to_use: HowToUse5;
  output_content: OutputContent5;
  publisher_kind?: PublisherKind;
  is_official?: IsOfficial;
  publisher_display_name: PublisherDisplayName2;
  category: Category2;
  tags: Tags2;
  published_at: PublishedAt;
  change_summary: ChangeSummary2;
  deprecation_message?: DeprecationMessage2;
  install_count: InstallCount;
  installed_version_id?: InstalledVersionId;
  installed_enabled?: InstalledEnabled;
  update_available?: UpdateAvailable;
  cover?: SkillCoverView | null;
}
export interface SkillCatalogPage {
  items: Items;
  next_offset?: NextOffset;
}
export interface SkillInstallRequest {
  version_id?: VersionId7;
}
export interface SkillInstallationView {
  skill_id: SkillId5;
  ref: Ref5;
  pinned_version_id: PinnedVersionId;
  version: Version5;
  enabled: Enabled2;
  available: Available;
  update_available: UpdateAvailable1;
  name: Name6;
  public_slug: PublicSlug5;
  display_name?: DisplayName6;
  description: Description6;
  use_when: UseWhen6;
  how_to_use: HowToUse6;
  output_content: OutputContent6;
  publisher_kind?: PublisherKind1;
  is_official?: IsOfficial1;
  publisher_display_name: PublisherDisplayName3;
  category: Category3;
  tags: Tags3;
  change_summary: ChangeSummary3;
  deprecation_message?: DeprecationMessage3;
  installed_at: InstalledAt;
  updated_at: UpdatedAt;
  cover?: SkillCoverView | null;
}
export interface SkillInstallationDetail {
  skill_id: SkillId6;
  ref: Ref6;
  pinned_version_id: PinnedVersionId1;
  version: Version6;
  enabled: Enabled3;
  available: Available1;
  update_available: UpdateAvailable2;
  name: Name7;
  public_slug: PublicSlug6;
  display_name?: DisplayName7;
  description: Description7;
  use_when: UseWhen7;
  how_to_use: HowToUse7;
  output_content: OutputContent7;
  publisher_kind?: PublisherKind2;
  is_official?: IsOfficial2;
  publisher_display_name: PublisherDisplayName4;
  category: Category4;
  tags: Tags4;
  change_summary: ChangeSummary4;
  deprecation_message?: DeprecationMessage4;
  installed_at: InstalledAt1;
  updated_at: UpdatedAt1;
  cover?: SkillCoverView | null;
  content_md: ContentMd6;
  files?: Files4;
}


export type DirectorSkillJsonValue =
  | string
  | number
  | boolean
  | null
  | DirectorSkillJsonValue[]
  | { [key: string]: DirectorSkillJsonValue };

export function isSkillManifestItem(
  value: DirectorSkillJsonValue,
): value is SkillManifestItem & { [key: string]: DirectorSkillJsonValue } {
  if (value === null || typeof value !== 'object' || Array.isArray(value)) return false;
  return (
    typeof value.ref === 'string' && value.ref.length > 0 &&
    (value.source === "builtin" || value.source === "user" || value.source === "published") &&
    typeof value.skill_id === 'string' && value.skill_id.length > 0 &&
    typeof value.version_id === 'string' && value.version_id.length > 0 &&
    typeof value.version === 'number' && Number.isInteger(value.version) &&
    typeof value.name === 'string' && value.name.length > 0 &&
    typeof value.public_slug === 'string' && value.public_slug.length > 0 &&
    typeof value.display_name === 'string' && value.display_name.length > 0 &&
    typeof value.description === 'string' && value.description.length > 0 &&
    typeof value.use_when === 'string' && value.use_when.length > 0 &&
    typeof value.how_to_use === 'string' && value.how_to_use.length > 0 &&
    typeof value.output_content === 'string' && value.output_content.length > 0
  );
}
